import React from 'react';
import type { ViewStyle } from 'react-native';
import { StyleSheet, Pressable, View } from 'react-native';

import { usePressableState } from '../../hooks';
import type { IconName } from '../Icon';
import { Icon } from '../Icon';
import { TextLink } from '../TextLink';

export const BackButton = ({
  containerStyle,
  label,
  icon,
  uppercase,
  onPress,
  accessibilityLabel,
}: BackButtonProps) => {
  const reference = React.useRef(null);
  const pressableState = usePressableState(reference);
  const labelStyle = [styles.label, uppercase && styles.labelUppercase];

  return (
    <Pressable
      ref={reference}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel ?? label ?? 'Go back'}
      testID="sg-back-button"
      style={[styles.container, containerStyle]}
      onPress={onPress}
    >
      <View style={styles.iconWrapper}>
        <Icon name={icon ?? 'IconLinkBack'} width={24} height={24} />
      </View>

      {label ? (
        <TextLink
          selectable={false}
          style={labelStyle}
          numberOfLines={1}
          underline={false}
          {...pressableState}
        >
          {label}
        </TextLink>
      ) : null}
    </Pressable>
  );
};

type BackButtonProps = {
  readonly label?: string;
  readonly icon?: IconName;
  readonly onPress: () => void;
  readonly accessibilityLabel?: string;
  readonly uppercase?: boolean;
  readonly isDisabled?: boolean;
  readonly containerStyle?: ViewStyle;
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  label: {
    marginLeft: 8,
  },
  labelUppercase: {
    textTransform: 'uppercase',
  },
  iconWrapper: {
    flexShrink: 0,
  },
});
